// generated file, if you want to edit this file manually change the word "generated" to "manual"
import React from "react";
import clsx from "clsx";
import { makeThemedStyles } from "./../utils";
import MaterialGrid from "@material-ui/core/Grid";
import { excludeKeys } from "./../utils";
const useStylesForKPIDetailsMenuContainer = makeThemedStyles(
  "KPIDetailsContent.KPIDetailsMenuContainer",
  (theme) => ({
    KPIDetailsMenuContainer: {
      maxWidth: "111px",
      position: "fixed",
    },
  })
);
type PropType = React.ComponentProps<typeof MaterialGrid>;
export const KPIDetailsMenuContainer: React.FunctionComponent<PropType> = (
  props: PropType
) => {
  const styles = useStylesForKPIDetailsMenuContainer();
  const enabledClasses = excludeKeys(styles, ["KPIDetailsMenuContainer"]);
  /* eslint-disable */
  return (
    <MaterialGrid
      {...props}
      classes={{
        root: styles.KPIDetailsMenuContainer,
        ...enabledClasses,
      }}
      className={clsx(styles.KPIDetailsMenuContainer)}
    >
      {props?.children}
    </MaterialGrid>
  );
};
export default KPIDetailsMenuContainer;
